import { render } from "./newsLst.vue?vue&type=template&id=3d78b561&scoped=true"
import script from "./newsLst.vue?vue&type=script&lang=js"
export * from "./newsLst.vue?vue&type=script&lang=js"

import "./newsLst.vue?vue&type=style&index=0&id=3d78b561&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d78b561"

export default script